import dayjs from 'dayjs';
import { formatCurrency } from '../../../../utils/helper';
import { Box } from '@mui/material';
import CustomTable from '../../../CustomTable';

const MobileItemsCards = ({ item }: { item?: any }) => {
    return (
        <>
            <Box key={item?.id} borderBottom='1px solid#EAECF0' p={2}>
                <Box width='full' justifyContent='space-between' display='flex'>
                    <Box display='flex' gap={1}>
                        <Box>
                            <h4 className=' text-ebony text-[12px] font-normal'>
                                Amount:{' '}
                                <span className='text-[14px] text-ebony font-semibold'>
                                    {formatCurrency(
                                        item?.amount ?? 0,
                                        item.currencyCode
                                    )}{' '}
                                </span>
                            </h4>
                            <p className=' text-[12px] text-paleSky whitespace-pre-line max-w-[320px] overflow-hidden'>
                                Comment:
                                <span className=' pl-1 pr-3 font-extrabold capitalize'>
                                    {item?.comment ?? '--'}
                                </span>
                            </p>

                            <p className=' text-[12px] text-paleSky'>
                                Created Date:
                                {dayjs(item?.createdDate).format('ll')}
                            </p>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const InvoicePaymentTable = ({
    loadingData,
    data
}: {
    loadingData?: boolean;
    data?: any;
}) => {
    return (
        <CustomTable
            data={data ?? []}
            loadingData={loadingData}
            emptyText='You have no Payment on this Invoice.'
            mobileComponent={<MobileItemsCards />}
            columns={[
                {
                    title: 'Date',
                    dataIndex: 'createdDate',
                    key: 'createdDate',
                    render: (_, record: any) => (
                        <span>{dayjs(record?.createdDate).format('ll')}</span>
                    )
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    render: (_, record: any) => (
                        <span>
                            {formatCurrency(
                                record?.amount || 0,
                                record?.currencyCode || 'NGN'
                            )}
                        </span>
                    )
                },
                {
                    title: 'Comment',
                    dataIndex: 'comment',
                    key: 'comment'
                }
            ]}
        />
    );
};
export default InvoicePaymentTable;
